export default function parseQueryString(queryString: string): {[key: string]: string} {
  return queryString
    .split('&')
    .map(pairs => pairs.split('='))
    .reduce((map, pair) => ({
      ...map,
      [pair[0]]: pair[1]
    }), {});
}